<template>
    <div class="m-auto md:w-2/4 shadow-md bg-white p-2 md:p-8 rounded-md">
        <template v-if="produit.par_niveau && !form.niveau">
            <template v-if="niveaux && niveaux.length">
                <button :id="niveau.id" v-for="niveau in niveaux"
                        class="w-full h-28 flex my-2 md:m-2 border-2 border-gray-300 shadow-xs hover:shadow-md text-left py-2 px-4 justify-center items-center"
                        @click="selectionNiveau(niveau.id)">
                    <span class="text-2xl font-bold overflow-hidden overflow-ellipsis">{{ __(niveau.constante) }}</span>
                </button>
            </template>
            <template v-else>
                <p class="text-center font-semibold">Aucun niveau n'est disponible.</p>
            </template>
        </template>
        <template v-else>
            <div>
                <h1 class="text-center text-2xl font-bold">Session</h1>
                <form
                    @submit.prevent="submit">
                    <p>{{ __('sessions_disponibles_pour_cette_periode') }}</p>
                    <p class="my-2 text-center text-sm text-gray-500" v-if="produit.choix_date_description" v-html="__(produit.choix_date_description)"></p>

                    <template v-if="produit.calendrier">
                        <date-picker></date-picker>
                    </template>

                    <div class="flex flex-col items-center justify-center my-2">
                        <template v-if="(!produit.enfants || produit.enfants.length < 1) && dates.length">
                            <label :id="date.id" v-for="date in dates"
                                   class="text-sm md:text-base inline-flex items-center mt-3 cursor-pointer">

                                <template v-if="date.complet"></template>
                                <template v-else-if="!produit.est_multiple">
                                    <input @click="ajouterProgrammation(date.id)" type="radio" :value="date.id" name="date" class="form-radio h-5 w-5 text-cavilam-primary">
                                </template>
                                <template v-else>
                                    <input v-model="form.programmes" type="checkbox" :value="date.id" name="date" class="form-checkbox h-5 w-5 text-cavilam-primary">
                                </template>

                                <template v-if="produit.par_semaines">
                                    <span class="ml-2 text-gray-700" v-html="__('programmation_semaine', [{key: 'DEBUT_MOIS', value: (new Date(date.date_debut)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'DEBUT_JOUR', value: (new Date(date.date_debut)).getDate()}, {key: 'DEBUT_ANNEE', value: (new Date(date.date_debut)).getFullYear()}])"></span>
                                </template>
                                <template v-else-if="!date.date_fin">
                                    <span class="ml-2 text-gray-700" v-html="__('programmation_date', [{key: 'DEBUT_MOIS', value: (new Date(date.date_debut)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'DEBUT_JOUR', value: (new Date(date.date_debut)).getDate()}, {key: 'DEBUT_ANNEE', value: (new Date(date.date_debut)).getFullYear()}])"></span>
                                </template>
                                <template v-else>
                                    <span class="ml-2 text-gray-700" v-html="__('programmation_periode', [{key: 'DEBUT_MOIS', value: (new Date(date.date_debut)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'DEBUT_JOUR', value: (new Date(date.date_debut)).getDate()}, {key: 'DEBUT_ANNEE', value: (new Date(date.date_debut)).getFullYear()}, {key: 'FIN_JOUR', value: (new Date(date.date_fin)).getDate()}, {key: 'FIN_MOIS', value: (new Date(date.date_fin)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'FIN_ANNEE', value: (new Date(date.date_fin)).getFullYear()}])"></span>
                                </template>
                                <template v-if="date.complet">
                                    <span class="text-red-700 font-semibold ml-2 ">(complet)</span>
                                </template>
                                &nbsp;
                                <span v-if="date.description" v-html="__(date.description)"></span>
                            </label>
                        </template>
                        <template v-else-if="produit.enfants.length && Object.keys(datesEnfantsVisibles).length">
                            <template v-for="(date, key) in datesEnfantsVisibles">
                                <label :id="date.id" v-if="date.programmes && date.programmes.length >= produit.choix_multiple_min"
                                       class="text-sm md:text-base inline-flex items-center mt-3 cursor-pointer">
                                    <input @click="changerDateEnfants(key)" type="radio" name="a_la_carte" class="form-radio h-5 w-5 text-cavilam-primary">

                                    <template v-if="produit.par_semaines">
                                        <span class="ml-2 text-gray-700" v-html="__('programmation_semaine', [{key: 'DEBUT_MOIS', value: (new Date(date.date_debut)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'DEBUT_JOUR', value: (new Date(date.date_debut)).getDate()}, {key: 'DEBUT_ANNEE', value: (new Date(date.date_debut)).getFullYear()}])"></span>
                                    </template>
                                    <template v-else-if="!date.date_fin">
                                        <span class="ml-2 text-gray-700" v-html="__('programmation_date', [{key: 'DEBUT_MOIS', value: (new Date(date.date_debut)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'DEBUT_JOUR', value: (new Date(date.date_debut)).getDate()}, {key: 'DEBUT_ANNEE', value: (new Date(date.date_debut)).getFullYear()}])"></span>
                                    </template>
                                    <template v-else>
                                        <span class="ml-2 text-gray-700" v-html="__('programmation_periode', [{key: 'DEBUT_MOIS', value: (new Date(date.date_debut)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'DEBUT_JOUR', value: (new Date(date.date_debut)).getDate()}, {key: 'DEBUT_ANNEE', value: (new Date(date.date_debut)).getFullYear()}, {key: 'FIN_JOUR', value: (new Date(date.date_fin)).getDate()}, {key: 'FIN_MOIS', value: (new Date(date.date_fin)).toLocaleString($page.props.metas.locale, { month: 'long' })}, {key: 'FIN_ANNEE', value: (new Date(date.date_fin)).getFullYear()}])"></span>
                                    </template>
                                    &nbsp;
                                    <span v-if="date.description" v-html="__(date.description)"></span>
                                </label>
                            </template>

                            <template v-if="Object.keys(choixEnfants).length">
                                <div class="w-5/6 mx-auto my-2 p-2 border-t text-center">
                                    <h2 class="font-bold mb-2" v-if="produit.choix_multiple_min > 1">{{ __('choisissez_vos_x_cours', [{key: 'NOMBRE_COURS', value: produit.choix_multiple_min}]) }}</h2>
                                    <h2 class="font-bold mb-2" v-else>{{ __('choisissez_votre_cours') }}</h2>

                                    <label :id="date.id" v-for="date in choixEnfants.programmes"
                                           class="inline-flex items-center mt-4 cursor-pointer w-full">
                                        <input v-model="form.programmes" type="checkbox" :value="date.programme.id" name="date" class="form-checkbox h-5 w-5 text-cavilam-primary">
                                        <span class="ml-2 text-gray-700 text-left" v-html="__(date.enfant.slug)"></span>
                                    </label>
                                </div>
                            </template>
                        </template>
                        <template v-else>
                            <p class="text-red-600 font-bold">{{ __('pas_de_date_disponible') }}</p>
                        </template>

                        <template v-if="produit.par_semaines && form.programmes.length">
                            <div class="custom-number-input w-1/2 text-center items-center mt-3">
                                <label for="semaines" class="w-full text-gray-700 text-sm font-semibold">
                                    <span v-if="produit.type_quantite === 'semaine'">{{ __('nombre_semaines') }}</span>
                                    <span v-else>{{ __('nombre_lecons') }}</span>
                                    <span class='has-tooltip ml-2'>
                                        <span class='tooltip rounded shadow-lg p-2 text-left bg-cavilam-primary text-white -mt-10'>
                                            <p class="text-center">
                                                <span class="font-bold">{{ __('min_lecons') }}</span> : {{ produit.semaines_min }} | <span class="font-bold">{{ __('max_lecons') }}</span> : {{ semainesMax }}
                                            </p>
                                            <template v-if="produit.paliers && produit.paliers.length">
                                                <template v-if="produit.paliers[0].semaines_min > produit.semaines_min">
                                                    <p>
                                                        <span class="font-bold">{{ __('x_a_x_lecons', [{key: 'nb_min', value: produit.semaines_min}, {key: 'nb_max', value: (produit.paliers[0].semaines_min-1)}]) }}</span> : {{ __('prix_regulier') }}
                                                    </p>
                                                </template>
                                                <template v-for="palier in anneeActuellePaliers">
                                                    <p>
                                                        <template v-if="palier.semaines_max">
                                                            <span class="font-bold">{{ __('x_a_x_lecons', [{key: 'nb_min', value: palier.semaines_min}, {key: 'nb_max', value: palier.semaines_max}]) }}</span> :
                                                        </template>
                                                        <template v-else>
                                                            <span class="font-bold">{{ __('x_ou_plus_lecons', [{key: 'nb_min', value: palier.semaines_min}]) }}</span> :
                                                        </template>
                                                        <template v-if="palier.pourcentage">
                                                            {{ __('economisez_x_lecons', [{key: 'REDUCTION', value: Math.round(palier.montant)+' %'}]) }}
                                                        </template>
                                                        <template v-else>
                                                            {{ __('economisez_x_lecons', [{key: 'REDUCTION', value: palier.montant_description}]) }}
                                                        </template>
                                                    </p>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <p>{{ __('pas_de_paliers') }}</p>
                                            </template>
                                            <svg class="absolute text-cavilam-primary h-4 left-0 ml-2 top-full" x="0px" y="0px" viewBox="0 0 255 255" xml:space="preserve"><polygon class="fill-current" points="0,0 127.5,127.5 255,0"/></svg>
                                        </span>
                                        <i class="fas fa-info-circle text-xl"></i>
                                    </span>
                                </label>
                                <div class="flex flex-row h-10 w-full rounded-lg relative bg-transparent mt-1">
                                    <button @click="updateSemainesCount('decrement', $event)" class=" bg-gray-300 text-gray-600 hover:text-gray-700 hover:bg-gray-400 h-full w-20 rounded-l cursor-pointer outline-none">
                                        <span class="m-auto text-2xl font-thin"><i class="fas fa-minus"></i></span>
                                    </button>
                                    <input id="semaines" type="number" :min="produit.semaines_min" :max="semainesMax" class="outline-none focus:outline-none text-center w-full bg-gray-300 font-semibold text-md hover:text-black focus:text-black  md:text-basecursor-default flex items-center text-gray-700  outline-none" name="semaines" v-model="form.nbSemaines">
                                    <button @click="updateSemainesCount('increment', $event)" class="bg-gray-300 text-gray-600 hover:text-gray-700 hover:bg-gray-400 h-full w-20 rounded-r cursor-pointer">
                                        <span class="m-auto text-2xl font-thin"><i class="fas fa-plus"></i></span>
                                    </button>
                                </div>
                            </div>
                        </template>
                    </div>
                    <div v-if="produit.afficher_prix" class="my-4 text-center">
                        <span class="text-cavilam-secondary font-semibold text-xl" v-html="montantTotal"></span>
                    </div>
                    <div class="mt-4 text-center">
                        <p v-if="showExceptionError" class="bg-yellow-100 p-2 mb-3">
                            {{ messageNousContacter(__('programme_inactive_nous_contacter')) }}
                        </p>
                        <breeze-button :class="{ 'opacity-25': form.processing || !peutEnvoyer || showExceptionError }" :disabled="form.processing || !peutEnvoyer || showExceptionError" id="TM-select-produit">
                            {{ __('valider') }}
                        </breeze-button>
                        <template v-if="produit.par_niveau">
                            <input name="niveau" type="hidden" v-model="form.niveau">
                        </template>
                    </div>
                </form>
                <div class="flex my-2" v-if="produit.par_niveau">
                    <div class="w-1/2">
                        <button class="inline-block px-6 py-2 text-xs font-medium
                            leading-6 text-center text-white uppercase
                            transition bg-yellow-400 rounded shadow ripple
                            hover:shadow-lg hover:bg-yellow-300 focus:outline-none"
                                @click="precedent">
                            <i class="fas fa-undo"></i> {{ __('precedent') }}
                        </button>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
import App from '@/Layouts/App'
import BreezeButton from '@/Components/Button'
import DatePicker from '@/Components/DatePicker'

export default {
    name: "Programmer",
    layout: App,
    components: {
        BreezeButton,
        DatePicker,
    },
    data: function () {
        return {
            afficherEnfants: null,
            form: this.$inertia.form({
                niveau: null,
                programmes: [],
                nbSemaines: (this.produit.par_semaines) ? this.produit.semaines_min : 1,
            }),
            datePicker: {
                mois: (new Date()).getMonth(),
                annee: (new Date()).getFullYear()
            },
            WEEK_MAX: 1,
        }
    },
    created:function() {
        let tarif = this.produit.tarifs.find(tarif => {
            return tarif.annee == (new Date()).getFullYear();
        });
        if (!tarif) tarif = this.produit.tarifs[0];

        dataLayer.push({ ecommerce: null });
        dataLayer.push({
            event: "view_item",
            ecommerce: {
                currency: "EUR",
                value: tarif.montant,
                items: [
                    {
                        item_id: this.produit.id,
                        item_name: this.__(this.produit.slug),
                        item_category: this.__(this.type.slug),
                        item_list_id: this.categorie.id,
                        item_list_name: this.__(this.categorie.slug),
                        price: tarif.montant,
                    }
                ]
            }
        });
        this.datePicker.mois = this.getPlusRecent().getMonth();
        this.datePicker.annee = this.getPlusRecent().getFullYear();
    },
    props: {
        type: Object,
        categorie: Object,
        produit: Object,
        niveaux: Array,
    },
    methods: {
        trierDates(dates) {
            return Object.keys(dates).sort().reduce(
                (obj, key) => {
                    obj[key] = dates[key];
                    return obj;
                },
                {}
            );
        },
        getPlusRecent() {
            let timestamp = '';

            if(this.produit.par_niveau && this.datesParNiveau.length) {
                timestamp = (new Date(this.datesParNiveau[0].date_debut)).setHours(0, 0, 0, 0);

                for(let row in this.datesParNiveau) {
                    let programme = this.datesParNiveau[row];
                    if((new Date(programme.date_debut)).setHours(0, 0, 0, 0) < timestamp) {
                        timestamp = (new Date(programme.date_debut)).setHours(0, 0, 0, 0);
                    }
                }
            } else if(this.produit.enfants.length && Object.keys(this.datesEnfants).length) {
                timestamp = (new Date(this.datesEnfants[Object.keys(this.datesEnfants)[0]].date_debut)).setHours(0, 0, 0, 0);

                for(let row in this.datesEnfants) {
                    let programme = this.datesEnfants[row];
                    if((new Date(programme.date_debut)).setHours(0, 0, 0, 0) < timestamp) {
                        timestamp = (new Date(programme.date_debut)).setHours(0, 0, 0, 0);
                    }
                }
            } else if(!this.produit.par_niveau && !this.produit.enfants.length && this.produit.programmes.length) {
                timestamp = (new Date(this.produit.programmes[0].date_debut)).setHours(0, 0, 0, 0);

                for(let row in this.produit.programmes) {
                    let programme = this.produit.programmes[row];
                    if((new Date(programme.date_debut)).setHours(0, 0, 0, 0) < timestamp) {
                        timestamp = (new Date(programme.date_debut)).setHours(0, 0, 0, 0);
                    }
                }
            } else {
                return (new Date());
            }

            return new Date(timestamp);
        },
        changerDateEnfants(index) {
            this.afficherEnfants = index;
            this.form.programmes = []; // On vide les cours qui avaient été pris
        },
        ajouterProgrammation(idProgramme) {
            this.form.programmes = [idProgramme];

            if (this.produit.slug == 'stages-de-perfectionnement-linguistique') {
                const programme = this.dates.find(date => {
                    return date.id === this.form.programmes[0];
                });
                this.setWeekMax(programme.date_fin);

                if (this.form.nbSemaines > this.WEEK_MAX) {
                    this.form.nbSemaines = this.WEEK_MAX;
                }
            }
        },
        getMontantProduitByDate(date = undefined) {
            let anneeDebut = (new Date()).getFullYear();
            let tarifs = this.produit.tarifs;

            if(!tarifs || tarifs.length < 0)
                return 0;

            if(date)
                anneeDebut = (new Date(date)).getFullYear();

            tarifs.sort((a, b) => (a.annee < b.annee) ? 1 : ((b.annee < a.annee) ? -1 : 0))

            for(let tarif in tarifs) {
                if(tarifs[tarif].annee <= anneeDebut) {
                    return tarifs[tarif].montant;
                }
            }
            return 0;
        },
        precedent() {
            this.form = this.$inertia.form({
                niveau: null,
                programmes: [],
                nbSemaines: this.produit.semaines_min,
            })
        },
        selectionNiveau: function(niveau_id) {
            this.form.niveau = niveau_id;
            this.datePicker.mois = this.getPlusRecent().getMonth();
            this.datePicker.annee = this.getPlusRecent().getFullYear();
        },
        submit() {
            this.form.post(this.route('inscription.programmer.enregistrer', {'type': this.type.slug, 'categorie': this.categorie.slug, 'produit': this.produit.slug}));
        },
        updateSemainesCount(action, event) {
            event.preventDefault();
            if (this.produit.slug == 'stages-de-perfectionnement-linguistique') {
                this.exceptionSemaineCount(action);
                return;
            }
            if(action === 'increment') {
                if(this.form.nbSemaines < this.semainesMax)
                    this.form.nbSemaines++;
                else
                    this.form.nbSemaines = this.semainesMax;
            } else if(action === 'decrement') {
                if(this.form.nbSemaines > this.produit.semaines_min)
                    this.form.nbSemaines--;
                else
                    this.form.nbSemaines = this.produit.semaines_min;
            }
        },

        // EXCEPTION : stages-de-perfectionnement-linguistique, date limite 30 Août 2024
        exceptionSemaineCount(action) {
            if(action === 'increment') {
                if(this.form.nbSemaines < this.WEEK_MAX)
                    this.form.nbSemaines++;
                else
                    this.form.nbSemaines = this.WEEK_MAX;
            } else if(action === 'decrement') {
                if(this.form.nbSemaines > this.produit.semaines_min)
                    this.form.nbSemaines--;
                else
                    this.form.nbSemaines = this.produit.semaines_min;
            }
        },
        setWeekMax(date) {
            // 0-11 is Month in JavaScript
            // On cherche le dernier vendredi du mois d'août
            const year = new Date(date).getFullYear();
            const vendredi = new Date(year, 8, 0);

            while (vendredi.getDay() !== 5) {
                vendredi.setDate(vendredi.getDate() - 1);
            }
            this.WEEK_MAX = this.weekDiff(new Date(date), vendredi) + 1;
        },
        weekDiff(date1, date2) {
            const WEEK = 7 * 24 * 60 * 60 * 1000;
            return Math.round((date2 - date1) / WEEK);
        },
        clampNbSemaines() {
            if (!this.form.programmes.length) return;
            if (this.form.nbSemaines > this.semainesMax)
                this.form.nbSemaines = this.semainesMax;
            if (this.form.nbSemaines < this.produit.semaines_min)
                this.form.nbSemaines = this.produit.semaines_min;
        },
        getDateKey(date) {
            const year = date.getFullYear();
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const day = String(date.getDate()).padStart(2, '0');
            return `${year}-${month}-${day}`;
        },
        getSemainesMaxProduit655() {
            if (this.produit.id !== 655 && this.produit.id !== 675) return null;
            if (!this.form.programmes.length) return null;

            const programme = this.dates.find(date => {
                return date.id === this.form.programmes[0];
            });

            if (!programme || !programme.date_debut) return null;

            const dateDebut = new Date(programme.date_debut);
            if (dateDebut.getFullYear() !== 2026) return null;

            const maxByDate = {
                '2026-06-22': 8,
                '2026-06-29': 7,
                '2026-07-06': 6,
                '2026-07-13': 5,
                '2026-07-20': 4,
                '2026-07-27': 3,
                '2026-08-03': 2,
                '2026-08-10': 1,
            };

            return maxByDate[this.getDateKey(dateDebut)] || null;
        },
        messageNousContacter(traduction) { // Sert a rendre dynamique le message quand un programme est inactif
            const programme = this.showExceptionError;
            if (!programme) return '';

            // La semaine du [DATE_DEBUT] au [DATE_FIN] [MOIS] est complète. Veuillez choisir d'autres dates pour votre séjour ou nous contacter directement à l'adresse info@cavilam.com.
            traduction = traduction.replace('[DATE_DEBUT]', (new Date(programme.date_debut)).getDate());
            traduction = traduction.replace('[DATE_FIN]', (new Date(programme.date_fin)).getDate());
            traduction = traduction.replace('[MOIS]', (new Date(programme.date_debut)).toLocaleString(this.$page.props.metas.locale, { month: 'long' }));
            return traduction;
        },
    },
    watch: {
        'form.programmes': function () {
            this.clampNbSemaines();
        }
    },
    computed:{
        semainesMax() {
            if (this.produit.slug == 'stages-de-perfectionnement-linguistique')
                return this.WEEK_MAX || this.produit.semaines_max;

            const maxSpecial = this.getSemainesMaxProduit655();
            if (maxSpecial)
                return Math.min(maxSpecial, this.produit.semaines_max);

            return this.produit.semaines_max;
        },
        anneeActuellePaliers() {
            if(!this.produit.paliers || !this.produit.paliers.length)
                return [];

            let annee = (new Date()).getFullYear();

            if(this.form.programmes.length) {
                let date = this.dates.find(date => {
                    return date.id === this.form.programmes[0];
                });

                if(date && date.date_debut)
                    annee = (new Date(date.date_debut)).getFullYear();
            }

            let result = [];
            let i = 0;
            do {
                result = this.produit.paliers.filter(palier => {
                    return palier.annee === (annee-i);
                });
                i++;
            } while(!result.length && i <= 5);

            return result;
        },
        choixEnfants() {
            if(this.afficherEnfants && this.datesEnfants)
                return this.datesEnfants[this.afficherEnfants];
            else
                return {};
        },
        datesEnfantsVisibles() {
            let listeProgrammes = this.datesEnfants;

            if(this.produit.calendrier) {
                Object.filter = (obj, predicate) =>
                    Object.keys(obj)
                        .filter( key => predicate(obj[key]) )
                        .reduce( (res, key) => (res[key] = obj[key], res), {} );

                listeProgrammes = Object.filter(listeProgrammes, programme => {
                    let date = programme.date_debut_inscription;
                    if(!date)
                        date = programme.date_debut;

                    if(
                        this.datePicker.annee === (new Date(date)).getFullYear()
                        && this.datePicker.mois === (new Date(date)).getMonth()
                    )
                        return true;
                    return false;
                });
            }

            return listeProgrammes;
        },
        datesEnfants() {
            let listeProgrammes = {};

            for(let row in this.produit.enfants) {
                let enfant = this.produit.enfants[row];
                for(let column in enfant.programmes) {
                    let programme = enfant.programmes[column];

                    let jour_debut = new Date(programme.date_debut);
                    let jour_fin = undefined;

                    if(programme.date_fin)
                        jour_fin = new Date(programme.date_fin);

                    let index = Math.round(jour_debut.getTime()/1000);

                    // On affiche pas les dates des modules qui se déroulent avant la date indiquée dans le produit
                    if(this.produit.modules_date_debut && jour_debut.getTime() < (new Date(this.produit.modules_date_debut)).getTime())
                        continue;

                    // On affiche pas les dates des modules qui se déroulent après la date indiquée dans le produit
                    if(this.produit.modules_date_fin && jour_debut.getTime() > (new Date(this.produit.modules_date_fin)).getTime())
                        continue;

                    if(!listeProgrammes[index])
                      listeProgrammes[index] = {'date_debut': new Date(programme.date_debut), 'date_fin': jour_fin, 'programmes': []};

                    listeProgrammes[index].programmes.push({'enfant': enfant, 'programme': programme});
                }
            }

            return this.trierDates(listeProgrammes);
        },
        datesParNiveau() {
            return this.produit.programmes.filter(programme => {
                for(let dateNiveau in programme.niveaux) {
                    if(this.form.niveau === programme.niveaux[dateNiveau].id)
                        return true;
                }
                return false;
            });
        },
        dates() {
            let listeDates = this.produit.programmes;

            if(this.produit.par_niveau) {
                listeDates = this.datesParNiveau;
            }

            if(this.produit.calendrier) {
                listeDates = listeDates.filter(programme => {
                    let date = programme.date_debut_inscription;
                    if(!date)
                        date = programme.date_debut;

                    if(
                        this.datePicker.annee === (new Date(date)).getFullYear()
                        && this.datePicker.mois === (new Date(date)).getMonth()
                    )
                        return true;
                    return false;
                });
            }

            // Uncheck radio checkboxes on date change
            document.querySelectorAll('input[type="radio"]').forEach((el) => {
                el.checked = false;
            });

            return listeDates;
        },
        showExceptionError() {
            // EXCEPTION : Désactiver semaine 28/07/25 et 04/08/25 pour les cours de français
            if (this.form.programmes.length == 0) return false;

            for (let programme_id of this.form.programmes) {
                const programme = this.dates.find(date => {
                    return date.id === programme_id;
                });

                if (!programme) return false;
                if (programme.est_inactif) {
                    return programme;
                }

                // On met l'exception que pour les cours français super intensif et immersion
                if (typeof programme.produit_id !== 'undefined' && (programme.produit_id === 3 || programme.produit_id === 4)) {

                    const start = new Date(programme.date_debut);
                    const end = new Date(programme.date_fin);
                    if (this.form.nbSemaines) {
                        const days = 7 * this.form.nbSemaines;
                        end.setDate(end.getDate() + days);
                    }

                    if (start.getTime() <= new Date(2025, 6, 28).getTime() && end.getTime() >= new Date(2025, 7, 8).getTime()) {
                        // On retourne ces dates pour afficher le message
                        return {
                            date_debut: new Date('2025-07-28'),
                            date_fin: new Date('2025-08-08'),
                        };
                    }
                }

                // Exception : bloquer les semaines du 13 et du 20 juillet 2026 pour Intensif, Super Intensif et Intensif Jeunes
                // uniquement pour les inscriptions à cette seule semaine (nbSemaines === 1)
                // Les lundis Paris sont stockés en DB en UTC+2 (CEST) : 13 juillet -> 2026-07-12T22:00:00Z, 20 juillet -> 2026-07-19T22:00:00Z
                if (typeof programme.produit_id !== 'undefined' &&
                    (programme.produit_id === 1 || programme.produit_id === 649 || programme.produit_id === 651 || programme.produit_id === 652 || programme.produit_id === 655)) {
                    const start = new Date(programme.date_debut);

                    // Semaine du 13 juillet 2026
                    const rangeDebut = new Date('2026-07-12T00:00:00Z');
                    const rangeFin   = new Date('2026-07-14T00:00:00Z');

                    if (start.getTime() >= rangeDebut.getTime() &&
                        start.getTime() <  rangeFin.getTime() &&
                        this.form.nbSemaines === 1) {
                        return {
                            date_debut: new Date(2026, 6, 13),
                            date_fin:   new Date(2026, 6, 19),
                        };
                    }

                    // Semaine du 20 juillet 2026 : uniquement le programme Super Intensif (649, 651, 652)
                    const rangeDebut20 = new Date('2026-07-19T00:00:00Z');
                    const rangeFin20   = new Date('2026-07-21T00:00:00Z');

                    if ((programme.produit_id === 649 || programme.produit_id === 651 || programme.produit_id === 652) &&
                        start.getTime() >= rangeDebut20.getTime() &&
                        start.getTime() <  rangeFin20.getTime() &&
                        this.form.nbSemaines === 1) {
                        return {
                            date_debut: new Date(2026, 6, 20),
                            date_fin:   new Date(2026, 6, 26),
                        };
                    }
                }
            }
            return false;
        },
        peutEnvoyer() {
            return !(this.form.programmes.length < 1 || ((this.produit.est_multiple || this.produit.enfants.length) && (
                (this.produit.choix_multiple_min && this.form.programmes.length < this.produit.choix_multiple_min) ||
                (this.produit.choix_multiple_max && this.form.programmes.length > this.produit.choix_multiple_max)
            )));
        },
        montantTotal() {
            let prixDates = 0;
            let nouveauPrixSemaines = 0;

            for(let selectedDate in this.form.programmes) {
                let date = this.dates.find(date => {
                    return date.id === this.form.programmes[selectedDate];
                });

                if(date) {
                    // Si on a un montant pour la date, il prend le dessus...
                    if(date.montant)
                        prixDates += parseFloat(date.montant);
                    else
                        prixDates += parseFloat(this.getMontantProduitByDate(date.date_debut));
                }
            }

            // On applique les promotions par paliers si c'est un cours par semaines
            let totalReduit = undefined;

            if(this.produit.par_semaines && this.anneeActuellePaliers && this.anneeActuellePaliers.length) {
                let paliersInverses = this.anneeActuellePaliers.slice().reverse();

                for(let palier in paliersInverses) {
                    let palierActuel = paliersInverses[palier];
                    let reduction = undefined;

                    if(this.form.nbSemaines >= palierActuel.semaines_min) {
                        // si y'a pas de semaines_max, c'est qu'il englobe tout
                        if(palierActuel.semaines_max) {
                            if(palierActuel.pourcentage) {
                                if(this.form.nbSemaines <= palierActuel.semaines_max)
                                    reduction = parseFloat(palierActuel.montant);
                            } else {
                                nouveauPrixSemaines = palierActuel.montant * this.form.programmes.length;
                                break;
                            }
                        } else {
                            if(palierActuel.pourcentage)
                                reduction = parseFloat(palierActuel.montant);
                            else
                                nouveauPrixSemaines = palierActuel.montant * this.form.programmes.length;
                            break;
                        }
                    }

                    if(reduction && palierActuel.pourcentage) {
                        totalReduit = parseFloat((parseFloat(prixDates) * this.form.nbSemaines) * (1-(reduction/100)));
                        break;
                    }
                }
            }

            if(!this.form.programmes || !this.form.programmes.length)
                return '';

            // Pour les cours par modules on prend le prix de l'année choisie pour les modules
            if(this.produit.enfants && this.produit.enfants.length && this.afficherEnfants) {
                prixDates = parseFloat(this.getMontantProduitByDate((new Date(this.afficherEnfants*1000)).toString()));
            }

            if(totalReduit)
                return '<span class="text-sm line-through">' + parseFloat(prixDates * this.form.nbSemaines).toFixed(2) + ' €</span> <span class="text-red-500">' + totalReduit + ' €</span>';
            else if(nouveauPrixSemaines)
                return '<span>' + parseFloat(nouveauPrixSemaines * this.form.nbSemaines).toFixed(2) + ' €</span>';

            return prixDates * this.form.nbSemaines + ' €';
        }
    }
}
</script>

<style scoped>
input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

.custom-number-input input:focus {
    outline: none !important;
}

.custom-number-input button:focus {
    outline: none !important;
}
</style>
